<div [ngClass]="stroke ? '' : 'text-' + color">
  <div
    [class]="stroke ? 'stroke-' + color : 'fill-current'"
    [ngClass]="width ? width : 'w-7.5'"
    [inlineSVG]="'./assets/icons/' + icon"
  ></div>
</div>
